export default __webpack_public_path__ + "72ddd775408239f5370d04922affcaa9.svg";